import React from "react";
import {
  isChunkLoadError,
  reloadOnceForChunkError,
  reloadPage,
  reportRenderError,
} from "../../utils/renderCrash";

class MarketplaceErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    reportRenderError(error, errorInfo, "MarketplaceErrorBoundary");
    reloadOnceForChunkError(error);
  }

  handleRetry = () => {
    if (isChunkLoadError(this.state.error)) {
      reloadPage();
      return;
    }
    this.setState({ hasError: false, error: null });
    if (this.props.onRetry) this.props.onRetry();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center", color: "#666" }}>
          <h2>Something went wrong</h2>
          <p>We're having trouble loading the marketplace right now.</p>
          <button
            type="button"
            onClick={this.handleRetry}
            style={{
              marginTop: 16,
              padding: "10px 20px",
              background: "#035BF0",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default MarketplaceErrorBoundary;